<template>
  <div v-if="isActive" class="modal-popup" @click="handleOverlayClick">
    <div class="popup google-refresh-popup" @click.stop>
      <div class="google-refresh-content">
        <!-- Header with Google icon -->
        <div class="page-header">
          <div class="page-avatar">
            <img src="@/assets/img/iconsNetwork/ico-google-2x.png" alt="Google" />
          </div>
          <h4>{{ $t('onboarding.google_refresh.title') }}</h4>
        </div>

        <!-- Explanation -->
        <p class="explanation">
          {{ $t('onboarding.google_refresh.explanation') }}
        </p>

        <!-- Step 1 -->
        <div class="step-card">
          <div class="step-number">1</div>
          <div class="step-content">
            <p class="step-title">{{ $t('onboarding.google_refresh.step1_title') }}</p>
            <p class="step-description">{{ $t('onboarding.google_refresh.step1_description') }}</p>
            <a
              href="https://myaccount.google.com/connections"
              target="_blank"
              rel="noopener noreferrer"
              class="step-link"
            >
              {{ $t('onboarding.google_refresh.step1_link_text') }}
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M11 7.66667V11.6667C11 12.0203 10.8595 12.3594 10.6095 12.6095C10.3594 12.8595 10.0203 13 9.66667 13H2.33333C1.97971 13 1.64057 12.8595 1.39052 12.6095C1.14048 12.3594 1 12.0203 1 11.6667V4.33333C1 3.97971 1.14048 3.64057 1.39052 3.39052C1.64057 3.14048 1.97971 3 2.33333 3H6.33333" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 1H13V5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M5.66699 8.33333L13.0003 1" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- Step 2 -->
        <div class="step-card">
          <div class="step-number">2</div>
          <div class="step-content">
            <p class="step-title">{{ $t('onboarding.google_refresh.step2_title') }}</p>
            <p class="step-description">{{ $t('onboarding.google_refresh.step2_description') }}</p>
          </div>
        </div>

        <!-- Buttons -->
        <div class="buttons">
          <div
            class="button btn-outline-primary"
            @click="handleSkip"
          >
            {{ $t('onboarding.google_refresh.button_skip') }}
          </div>
          <div
            class="button btn-primary"
            @click="handleReconnect"
          >
            {{ $t('onboarding.google_refresh.button_reconnect') }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoogleRefreshModal',

  props: {
    active: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      isActive: false
    }
  },

  watch: {
    active(newVal) {
      this.isActive = newVal
    }
  },

  methods: {
    handleOverlayClick(event) {
      if (event.target.classList.contains('modal-popup')) {
        this.handleSkip()
      }
    },

    handleSkip() {
      this.isActive = false
      this.$emit('skip')
    },

    handleReconnect() {
      this.isActive = false
      this.$emit('reconnect')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../variables.scss';

.google-refresh-popup {
  max-width: 520px;
}

.google-refresh-content {
  .page-header {
    text-align: center;
    margin-bottom: 16px;

    .page-avatar {
      width: 56px;
      height: 56px;
      margin: 0 auto 12px;
      border-radius: 50%;
      overflow: hidden;
      background: $bg-ui-selected;
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    h4 {
      margin: 0;
      color: #111827;
      font-size: 18px;
      font-weight: 600;
    }
  }

  .explanation {
    color: #6b7280;
    font-size: 14px;
    line-height: 1.6;
    text-align: center;
    margin-bottom: 24px;
  }

  .step-card {
    display: flex;
    gap: 14px;
    padding: 16px;
    background: $bg-ui-selected;
    border-radius: 10px;
    margin-bottom: 12px;

    .step-number {
      flex-shrink: 0;
      width: 28px;
      height: 28px;
      border-radius: 50%;
      background: $primary-color;
      color: #ffffff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      font-weight: 600;
    }

    .step-content {
      flex: 1;

      .step-title {
        font-size: 14px;
        font-weight: 600;
        color: #111827;
        margin: 0 0 4px 0;
      }

      .step-description {
        font-size: 13px;
        color: #6b7280;
        margin: 0 0 8px 0;
        line-height: 1.5;
      }

      .step-link {
        display: inline-flex;
        align-items: center;
        gap: 6px;
        font-size: 13px;
        font-weight: 500;
        color: $primary-color;
        text-decoration: none;
        transition: opacity 0.15s;

        &:hover {
          opacity: 0.8;
          text-decoration: underline;
        }

        svg {
          flex-shrink: 0;
        }
      }
    }
  }

  .buttons {
    display: flex;
    gap: 12px;
    margin-top: 24px;
  }
}
</style>
